import React from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import '../css/Task.css'; // Import your CSS file
import Zahid from '../pages/Zahid';
import Mayesha from '../pages/Mayesha';
import Ashad from '../pages/Ashad';
import Sani from '../pages/Sani';


const Task = () => {
  return (
    
    <div className="unique-tabs-container"> {/* Add the unique-tabs-container class */}
  
      <Tabs
        defaultActiveKey="contact"
        id="fill-tab-example"
        className="mb-3"
        fill
      >

        <Tab eventKey="contact" title={<span className="title">Md. Ashaduzzaman Nur</span>}>
          <Ashad />
        </Tab>
        <Tab eventKey="profile" title={<span className="title">Kazi Mayesha Mehzabin</span>}>
          <Mayesha />
        </Tab>
        <Tab eventKey="home" title={<span className="title">Md. Zahidul Islam</span>}>
          <Zahid />
        </Tab>
        <Tab eventKey="longer-tab" title={<span className="title">Saniul Islam Sani</span>}>
          <Sani />
        </Tab>

      </Tabs>

    </div>
  );
}

export default Task;
